import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import carrieThumb from 'images/carrie_thumb16.jpeg';
import { type CardLayoutModelConstructorType } from '../../types';
import { type User } from 'components/framework/models';

export class AssigneeImage extends Field {
  static subqueriesForModel(
    modelClass: CardLayoutModelConstructorType
  ): Record<string, any> {
    switch (modelClass.typename) {
      case 'Task':
        return { users: ['name', 'avatarUrl', 'initials'] };

      default:
        return { assignedToUser: ['name', 'avatarUrl', 'initials'] };
    }
  }

  get title() {
    return 'Assignee image';
  }

  exampleContents(): FieldContentsData {
    return { avatar: { src: carrieThumb, name: 'User name', initials: 'UN' } };
  }

  contentsForRecord(record): FieldContentsData {
    const user: User | undefined =
      record.typename === 'Task' ? record.users[0] : record.assignedToUser;

    if (user) {
      const { avatarUrl: src, name, initials } = user;
      return { avatar: { src, name, initials } };
    }

    return {};
  }
}
